const ERROR_MESSAGES = {
  NON_V2_ROOM: 'Error Joining Room: Cannot join a non-V2 room.',
  MISSING_PARAMS: 'Missing required params',
  UNAUTHORIZED: 'Unauthorized',
};

// Custom error classes
class NonV2RoomError extends Error {
  constructor(message = ERROR_MESSAGES.NON_V2_ROOM) {
    super(message);
    this.name = 'NonV2RoomError';
  }
}

class MissingParamsError extends Error {
  constructor(message = ERROR_MESSAGES.MISSING_PARAMS) {
    super(message);
    this.name = 'MissingParamsError';
  }
}

class UnauthorizedError extends Error {
  constructor(message = ERROR_MESSAGES.UNAUTHORIZED) {
    super(message);
    this.name = 'UnauthorizedError';
  }
}

export {
  ERROR_MESSAGES,
  NonV2RoomError,
  MissingParamsError,
  UnauthorizedError,
};
